import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
// import 'antd/dist/antd.css';
import 'ant-design-pro/dist/ant-design-pro.css';
import './index.less';

try {
    ReactDOM.render(
        <App />,
        document.getElementById('root') as HTMLElement
    );
} catch (error) {
    console.error(error);
}


// WEBPACK FOOTER //
// ./src/index.tsx